import SpriteSymbol from "../../../../ProSpace/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../ProSpace/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-and-point",
  "use": "icon-line-and-point-usage",
  "viewBox": "0 0 12 3",
  "content": "<symbol viewBox=\"0 0 12 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-and-point\">\n    <circle cx=\"10.5\" cy=\"1.5\" r=\"1.5\" fill=\"#B0BEC5\" />\n    <line x1=\"-4.37114e-08\" y1=\"1.5\" x2=\"10\" y2=\"1.5\" stroke=\"#B0BEC5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol